import PropTypes from 'prop-types';
import React from 'react';
import FootballMatchPlayerGoals from './FootballMatchPlayerGoals';
import CompactText from 'modules/Common/components/CompactText';

export default function FootballMatchTeamStatus({
    players,
    team: {
      team: {
        name,
        short_name
      },
      goals
    }
  }) {
  const sentOffPlayers = players
    .filter(player => (player.redCardTime || player.secondYellowCardTime))
    .map(player => ({
      id: player.player.player_reference.id,
      time: player.redCardTime || player.secondYellowCardTime,
      name: player.name
    }));

  return (
    <div className="footballMatchTeamStatus">
      <h2 className="footballMatchTeamName">
        <CompactText compactText={short_name}>{name}</CompactText>
      </h2>
      <div className="small-copy">
        {goals.map(goal => (
          <div key={goal.id}><FootballMatchPlayerGoals playerGoals={goal}/></div>
        ))}
        {sentOffPlayers.map(({id, time, name}) => (
          <div className="FootballMatchStatusRedCard" key={id}>{name} s/o {time}</div>
        ))}
      </div>
    </div>
  );
}

FootballMatchTeamStatus.propTypes = {
  team: PropTypes.shape({
    team: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
    goals: PropTypes.array.isRequired
  }).isRequired,
  players: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchTeamStatus.js